/**
 * 작성자 : 홍선영
 * 날짜 : 2024.12.23
 * 기능 : (사내)사내관리-사원정보-사원정보
 */

import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { ContentsContainerRoot } from '../../../assets/styles/ContentsContainerRoot';
import { useEffect, useState } from 'react';
import List from './list';
import Form from './form';
import { ICuser } from 'customTypes';
import GetFetchStatus from '../../../hooks/GetFetchStatus';
import BackButton from '../../../components/BackButton';
import { useTranslation } from 'react-i18next';
import useBackHistory from '../../../hooks/useBackHistory';

const Root = styled(ContentsContainerRoot)`
  &.hideRoot {
    visibility: hidden;
    position: absolute;
  }
  .formTitle {
    padding: 0 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: var(--text-primary);
  }
  .inputFormsWrapper {
    border-bottom: 1px solid var(--outline);
    padding: 0.5rem;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    .table {
      height: fit-content;
    }
  }
`;

const CompanyUserInfo = () => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const [viewTable, setViewTable] = useState<boolean>(true);
  const [rowState, setRowState] = useState<ICuser | null>(null);
  const { data: userList, isLoading, isError } = GetFetchStatus({ path: '/user/company', hCdOnly: { value: true, key: 'hCd' } });
  const [tableState, setTableState] = useState<ICuser[] | null>(null);

  useEffect(() => {
    if (rowState !== null) setViewTable(false);
  }, [rowState]);

  const backToMain = () => {
    setViewTable(true);
  };

  const { onBackPrev } = useBackHistory({ isOpen: !viewTable, onPrev: backToMain, pageName: 'companyUserInfo' });

  const loading = !userList || isLoading;

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <Root loading={loading} className={size.innerSize.W > 1024 || viewTable ? 'showRoot' : 'hideRoot'}>
        <List data={userList} isLoading={loading} isError={isError} tableState={tableState} setTableState={setTableState} setRowState={setRowState} />
      </Root>
      {(size.innerSize.W > 1024 || !viewTable) && (
        <Root loading={loading}>
          <div className='inputFormsWrapper flexRowEm'>
            {size.innerSize.W <= 1024 && <BackButton func={onBackPrev} />}
            {/* <div className='formTitle'>{rowState !== null && t('사원 정보')}</div> */}
          </div>
          <Form rowState={rowState} setRowState={setRowState} />
        </Root>
      )}
    </div>
  );
};

export default CompanyUserInfo;
